// @ts-strict-ignore
import { useRef, useState } from 'react'

import { AccessoryProductCard } from '@/widgets/ProductCard'

import { SlideProps } from '../AccessoriesCarousel'
import styles from '../AccessoriesCarousel.module.scss'

/**
 * Accessories carousel slides view type
 * @param items
 * @param catalogItemType
 * @param sectionName
 * @param sectionId
 * @param relatedId
 * @param location – Component location (Need for GTM)
 */
export const Slides = (props: SlideProps) => {
	const { items, sectionName, sectionId, relatedId, location } = props

	const sliderRef = useRef(null)
	const [startX, setStartX] = useState(0)
	const [scrollLeft, setScrollLeft] = useState(0)
	const [isDragging, setIsDragging] = useState(false)
	const [mouseIsDown, setMouseIsDown] = useState(false)

	const stopDragging = () => {
		setIsDragging(false)
		setMouseIsDown(false)
	}

	const onMouseDown = () => {
		setMouseIsDown(true)
	}

	const onMouseMove = evt => {
		if (mouseIsDown) {
			if (!isDragging) {
				setIsDragging(true)
				setStartX(evt.pageX - sliderRef.current.offsetLeft)
				setScrollLeft(sliderRef.current.scrollLeft)
			} else {
				evt.preventDefault()
				const x = evt.pageX - sliderRef.current.offsetLeft
				const walk = (x - startX) * 3 //scroll-fast

				sliderRef.current.scrollLeft = scrollLeft - walk
			}
		}
	}

	const innerClasses = [styles.inner, isDragging && styles.isDragging].filter(Boolean).join(' ')

	return (
		<div
			ref={sliderRef}
			className={innerClasses}
			onMouseMove={onMouseMove}
			onMouseUp={stopDragging}
			onMouseDown={onMouseDown}
			onMouseLeave={stopDragging}>
			{Object.values(items).map(item => (
				<div className={styles.card} key={item.ID}>
					<AccessoryProductCard
						accessory={item}
						mainProductId={relatedId ?? 0}
						sectionId={sectionId}
						sectionName={sectionName}
						location={location}
					/>
				</div>
			))}
		</div>
	)
}
